import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Spin, message, Button } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../config";

const RoleBasedRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    const fetchRole = async () => {
      // Try cached role first for instant rendering
      const cachedRole = localStorage.getItem("userRole");
      if (cachedRole) {
        setUserRole(cachedRole);
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(
          `${API_BASE_URL}/authapp/api/v1/get_role/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const role = response.data.role;
        localStorage.setItem("userRole", role);
        setUserRole(role);
      } catch (error) {
        console.error("Failed to fetch role:", error);
        setIsError(true);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchRole();
    } else {
      setLoading(false);
    }
  }, [token]);

  if (!token) return <Navigate to="/signin" replace />;
  if (loading) return <Spin> Loading...</Spin>;

  if (isError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
        <div className="text-rose-500 text-lg font-semibold">Failed to verify access</div>
        <p className="text-gray-500 text-sm">Unable to reach the server. Please check your connection.</p>
        <Button type="primary" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </div>
    );
  }

  if (!allowedRoles.includes(userRole)) {
    if (!unauthorized) {
      setUnauthorized(true);
      message.error(
        "Unauthorized access! You do not have permission to view this page."
      );

      setTimeout(() => {
        // navigate(-1);
        navigate("/signin");
      }, 3000);
    }
    return null;
  }

  return element;
};

export default RoleBasedRoute;
